// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__Vvk+h","total":"Cart_total__Dlxps","actions":"Cart_actions__PwToq","button--alt":"Cart_button--alt__zIqwc","button":"Cart_button__HxBSR"};